import { render, staticRenderFns } from "./mortgagee-form.vue?vue&type=template&id=70106ee8&scoped=true&"
import script from "./mortgagee-form.vue?vue&type=script&lang=js&"
export * from "./mortgagee-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70106ee8",
  null
  
)

export default component.exports